import { getGroupes } from '../api/GROUPES/groupes';
import { useQuery } from '@tanstack/react-query';

export const useGroupes = () => {
  return useQuery({
    queryKey: ['groupes'],
    queryFn: getGroupes,
    staleTime: 4 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
